/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-16 18:30:21
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-15 11:15:43
 */
export default {
	"action.button.next": "Continue",
	"action.button.back": "Back",
	"action.button.submit": "Submit",
	"action.button.confirm": "Confirm",
	"action.button.update": "Update",
	"action.button.edit": "Edit",
	"action.button.cancel": "Cancel",
	"action.button.reset": "Reset",

	"action.button.copy": "Copy",
	"action.button.search": "Search",
	"action.button.auth": "Authorize",
	"action.button.saveAsTemplate": "Save as template",
	"action.button.delete": "Delete",
	"action.button.close": "Close",

	"action.button.use": "Use",
	"action.button.use to all": "Apply to all"
};
